import Vuex from 'vuex';

import auth from 'store/auth';
import common from 'store/common';
import developer from 'store/developer';
import filters from 'store/filters';
import formClipboard from 'store/formclipboard';
import license from 'store/license';
import memberships from 'store/memberships';
import portals from 'store/portals';
import reservables from 'store/reservables';
import reservableEdit from 'store/reservableedit';
import search from 'store/search';
import session from 'store/session';
import settings from 'store/settings';
import sitesearch from 'store/sitesearch';
import theme from 'store/theme';

import { createModule } from 'store/toast';

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    auth,
    common,
    developer,
    filters,
    formClipboard,
    license,
    memberships,
    portals,
    reservables,
    reservableEdit,
    search,
    session,
    settings,
    sitesearch,
    theme,
    toast: createModule({
      dismissInterval: 4000,
    }),
  },
  strict: debug,
});

if (window.Cypress) {
  // only available during E2E tests
  // eslint-disable-next-line no-underscore-dangle
  window.__store__ = store;
}

export default store;
